/**
 * edu 系のメールアドレスは Bounce する可能性が極めて高いので、
 * 警告を出すために、判定する
 */
export function isEduEmail(email?: string) {
  return email ? email.endsWith('edu.jp') || email.endsWith('ed.jp') : false;
}
